<template>
    <div
        class="dk-color-thumb"
        :class="parentSizeClass"
        @click="onClick"
        @mouseenter="hasCustomHover && onMouseEnter()"
        @mouseleave="hasCustomHover && onMouseLeave()"
    >
        <div
            class="dk-color-thumb__icon tw-relative tw-flex tw-justify-center tw-items-center tw-rounded-full tw-cursor-pointer"
            :class="thumbClasses"
            :style="thumbStyle"
        >
            <dk-icon
                v-if="showMore && !isThreeStepsDkPromo"
                class="dk-color-thumb__icon-svg"
                name="ds-dots-horizontal"
                size="s"
                color="slate-300"
            />
            <dk-icon
                v-if="showMore && isThreeStepsDkPromo"
                class="dk-color-thumb__icon-svg"
                name="ds-plus-default"
                size="s"
                :color="iconColor"
            />
            <dk-icon
                v-if="showLess && isThreeStepsDkPromo"
                class="dk-color-thumb__icon-svg"
                name="ds-minus-default"
                size="s"
                :color="iconColor"
            />
        </div>
    </div>
</template>

<script>
import DkIcon from '@v4/common/components/atoms/DkIcon.vue';

export default {
    name: 'DkColorThumb',
    components: {
        DkIcon,
    },
    props: {
        /**
         * Array of strings with color variables.`
         */
        color: {
            type: Object,
            default: null,
        },
        /**
         * Available sizes: 's', 'l'.
         */
        size: {
            type: String,
            default: '',
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        showMore: {
            type: Boolean,
            default: false,
        },
        /*
         * A flag for the custom classes for the 3-steps DkPromo page.
         */
        isThreeStepsDkPromo: {
            type: Boolean,
            default: false,
        },
        /*
         * A flag for the custom button for the 3-steps DkPromo page.
         */
        showLess: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isCurrentSelection: this.isSelected,
            isHovered: false,
        };
    },
    computed: {
        parentSizeClass() {
            let classes =
                'tw-relative tw-p-2 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-300';

            if (this.size === 's') {
                classes += ' tw-w-14 tw-h-14';
            } else {
                classes += ' tw-w-14 tw-h-14 lg:tw-w-18 lg:tw-h-18';
            }

            if (this.isDisabled) {
                classes += ' tw-opacity-[.5] tw-pointer-events-none';
            }

            return classes;
        },
        thumbClasses() {
            let classes = '';

            if (!this.isThreeStepsDkPromo) {
                classes +=
                    ' tw-outline tw-outline-offset-[3px] tw-outline-1 tw-outline-slate-300 hover:lg:tw-outline-2';
            }

            if (this.isCurrentSelection && !this.isThreeStepsDkPromo) {
                classes += ' !tw-outline-2 !tw-outline-slate-500';
            }

            if (this.isThreeStepsDkPromo) {
                if (this.isHovered) {
                    classes += ' tw-bg-negative-subtle';
                } else if (this.showMore || this.showLess) {
                    classes += ' tw-bg-border-color';
                }
            }

            classes += this.size === 's' ? ' tw-w-10 tw-h-10' : ' tw-w-10 tw-h-10 lg:tw-w-14 lg:tw-h-14';

            return classes;
        },
        thumbStyle() {
            if (!this.color) {
                return;
            }
            if (this.color.primaryHex && !this.color.secondaryHex) {
                return { backgroundColor: `${this.color.primaryHex}` };
            }

            return {
                background: `linear-gradient(135deg, ${this.color.primaryHex} 0%, ${this.color.primaryHex} 50%, ${this.color.secondaryHex} 51%, ${this.color.secondaryHex} 100%)`,
            };
        },
        hasCustomHover() {
            return this.isThreeStepsDkPromo && (this.showMore || this.showLess);
        },
        iconColor() {
            return this.isHovered ? 'slate-600' : 'slate-300';
        },
    },
    watch: {
        isSelected(newValue) {
            this.isCurrentSelection = newValue;
        },
    },
    methods: {
        onClick() {
            if (this.showMore) {
                this.$emit('show-more');
                this.isHovered = false;
            } else if (this.showLess) {
                this.$emit('show-less');
                this.isHovered = false;
            } else {
                this.$emit('select-color');
            }
        },
        onMouseEnter() {
            this.isHovered = true;
        },
        onMouseLeave() {
            this.isHovered = false;
        },
    },
};
</script>
